import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/mobile`;

class MobileUsersServices {
  async getAllMobileUserData(page, limit, filter) {
    try {
      const action =
        API_ROUTE +
        `/get-all_mobile-users?page=${page}&limit=${limit}&filter=${filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getAllMobileUserData:", error);
      throw error;
    }
  }

  async addMobileUserData(payload) {
    try {
      const action = API_ROUTE + `/add-mobile_user-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in addMobileUserData:", error);
      throw error;
    }
  }

  async updateMobileUserData(payload) {
    try {
      const action = API_ROUTE + `/update-mobile_user-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in updateMobileUserData:", error);
      throw error;
    }
  }

  async deleteMobileUser(userId) {
    try {
      const action = API_ROUTE + `/delete-mobile_user-data?id=${userId}`;
      return await requestToken.del(action);
    } catch (error) {
      console.error("Error in deleteMobileUser:", error);
      throw error;
    }
  }

  async toggleMobileStatus(payload) {
    try {
      const action = API_ROUTE + "/update-mobile-user-status";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }

  async addMobileWalletBalanceBySA(payload) {
    try {
      const action = API_ROUTE + "/update-mobile-wallet";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }

  async unblockMobileUser(payload) {
    try {
      const action = API_ROUTE + "/unblock-mobile-user";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }

  async assignTemplate(payload) {
    try {
      const action = API_ROUTE + "/assign-template";
      return await requestToken.post(action, payload);
    } catch (error) {
      throw error;
    }
  }
}

export default MobileUsersServices;

